// Utility functions for role-based routing

// Helper function to get role-based prefix
export const getRolePrefix = (roles) => {
  if (roles.includes("Admin")) return "/admin";
  if (roles.includes("Manager")) return "/manager";
  if (roles.includes("HR")) return "/hr";
  if (roles.includes("HOD")) return "/hod";
  if (roles.includes("User")) return "/user";
  return "/"; // fallback
};

// Helper function to generate role-based routes
export const getRoleBasedRoute = (route, roles) => {
  const rolePrefix = getRolePrefix(roles);
  // Remove the /admin prefix if it exists and replace with role prefix
  const cleanRoute = route.startsWith('/admin/') ? route.substring(7) : route;
  return `${rolePrefix}/${cleanRoute}`;
};

// Helper function to check if a path matches any role-based variant
export const isRoleBasedPath = (path, roles) => {
  const rolePrefix = getRolePrefix(roles);
  const cleanPath = path.startsWith('/admin/') ? path.substring(7) : path;
  return path === `${rolePrefix}/${cleanPath}` || path === `/admin/${cleanPath}` || path === cleanPath;
}; 